// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;
import ClipboardJS from 'clipboard';
import yearDropdownPlugin from './modules/flatpickrYearDropdown';

// load fonts
WebFont.load({
    google: { // add &display=swap to end of ONLY END font family, not every single one, other it doesnt load those fonts after
        families: ['Open Sans:300,400,500,600,700&display=swap']
    },
    active: function () { // helps stop flash of unstyled text
        sessionStorage.fontsLoaded = true
    }
});

// Load BS
require('bootstrap');

//Load Libraries
require('flatpickr/dist/flatpickr.min');
require('magnific-popup/dist/jquery.magnific-popup.min');
// require('objectFitPolyfill/dist/objectFitPolyfill.min');
require('select2/dist/js/select2.full.min');
require('slick-slider/slick/slick.min');

//Load Modules
require('./modules/accordion');
// require('./modules/animatein');
require('./modules/bannerVideo');
require('./modules/formInputs');
// require('./modules/localVideoBlock');
require('./modules/menu');
require('./modules/menuFilters');
require('./modules/modal');
require('./modules/scrollTo');
// require('./modules/searchToggle');
require('./modules/shareSocial');
// require('./modules/sideMenu');
require('./modules/tabs');
// require('./modules/alert');
require('./modules/carouselSliderImplementations');
require('./modules/wishlistButton');

// Ajax Chalet Search
require('./modules/ajaxChaletSearch');


// set datepicker for header data input
$(function () {
    $(document).ready(function () {
        const startDate = $('#enquiryform-start_date');
        const endDate = $('#enquiryform-end_date');
        const flatPickrOptions = {
            altInput: true, // creates new visual input
            altFormat: "F j, Y", // sets the format to be more friendly, i.e. Thursday 8th April 2021
            dateFormat: "Y-m-d", // sets the format to match server-side data i.e. 2021-04-08
            disableMobile: true,
            minDate: "today",
            locale: {
                firstDayOfWeek: 1, // sets Monday to first day of the week
            },
            onMonthChange: function (selectedDates, dateStr, instance) {
                this.yearSelectContainer.querySelector('select').value = '' + instance.currentYear;
            }
        }

        $('.__date input').each(function() {
            const thisInput = $(this);

            // Date picker
            flatpickr(thisInput, {
                ...flatPickrOptions,
                plugins: [
                    new yearDropdownPlugin({
                      date: this.value,
                      yearStart: this.yearStart,
                      yearEnd: this.yearEnd
                    })
                ],
            });
        })

        flatpickr(startDate, {
            ...flatPickrOptions,
            plugins: [
                new yearDropdownPlugin({
                  date: this.value,
                  yearStart: this.yearStart,
                  yearEnd: this.yearEnd
                })
            ],
            onValueUpdate: function() {
                flatpickr(endDate, {
                    ...flatPickrOptions,
                    plugins: [
                        new yearDropdownPlugin({
                        date: this.value,
                        yearStart: this.yearStart,
                        yearEnd: this.yearEnd
                        })
                    ],
                    minDate: startDate.val() > endDate.val() ? startDate.val() : endDate.val(),
                })
            }
        })

        // Multiple selects on the same page, using the same class, must have a unique ID
        $('.__select select').each(function () {
            var selectId = $(this).parent();

            $(this).select2({
                containerCssClass: 'select2-css',
                minimumResultsForSearch: Infinity,
                dropdownParent: selectId,
                width: '100%',
            })
        });
    });
});

$(document).ready(function () {
    const headerHeight = $('.header').outerHeight(true);
    const body = $('body');

    body.css({
        'padding-top': `${headerHeight}px`
    })
});

new ClipboardJS('.__share');

$('.__share').each(function () {
    const thisElement = $(this);

    thisElement.click(function () {
        $(this).text('Copied');

        setTimeout(function () {
            thisElement.text('Share');
        }, 3000);
    })
});

$(function () {
    $(document).ready(function () {
        $(".resort-banner-textslider").each(function () {
            const thisElement = $(this);
            const relatedImageSlider = thisElement.closest('.resort-banner').find('.resort-banner-imageslider');
            const totalSlideCount = thisElement.closest('.resort-banner').find('.totalSlides');
            const currentSlideCount = thisElement.closest('.resort-banner').find('.currentSlide');

            thisElement.on('init reInit', function (event, slick) {
                totalSlideCount.text(slick.slideCount);
            });

            thisElement.on('init reInit afterChange', function (event, slick, currentSlide) {
                if (!currentSlide) {
                    currentSlideCount.text(1);
                } else {
                    currentSlideCount.text(currentSlide + 1);
                }
            });

            thisElement.slick({
                fade: true,
                dots: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: false,
                nextArrow: false,
                mobileFirst: true,
                draggable: false,
                speed: 0,
                asNavFor: relatedImageSlider,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1
                        }
                    },
                ]
            });
        })

        $('.floorplans').each(function() {
            const thisFloorPlan = $(this);
            const floorPlanModals = thisFloorPlan.find('.floorplans-imagemodal');

            floorPlanModals.magnificPopup({
                type: 'image',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false,
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
                },
                image: {
                    titleSrc: 'title'
                }
            })
        })

        $(".resort-banner-imageslider").each(function () {
            const thisElement = $(this);
            const relatedTextSlider = thisElement.closest('.resort-banner').find('.resort-banner-textslider');

            thisElement.on('init reInit', function () {
                $(this).find('.imagemodal').magnificPopup({
                    type: 'image',
                    removalDelay: 160,
                    preloader: false,
                    fixedContentPos: false,
                    gallery: {
                        enabled: true,
                        navigateByImgClick: true,
                        preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
                    },
                    image: {
                        titleSrc: 'title'
                    }
                });
            })

            thisElement.slick({
                fade: true,
                dots: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: thisElement.closest('.resort-banner').find('.sliderPrevButton'),
                nextArrow: thisElement.closest('.resort-banner').find('.sliderNextButton'),
                mobileFirst: true,
                draggable: false,
                asNavFor: relatedTextSlider,
                speed: 0,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1
                        }
                    },
                ]
            });
        });

        $('.showFilters').each(function () {
            const thisButton = $(this);
            const relatedFilters = $(this).closest('.filters').find('.filters-form');

            const setFilterDisplay = function (displayValue) {
                relatedFilters.css({
                    'display': `${displayValue}`
                })
            }

            thisButton.click(function () {
                if ($(this).hasClass('__toggled')) {
                    $(this).removeClass('__toggled');
                    $(this).html('Start a search <span class="icon icon-Chevron-Right"></span>');
                    setFilterDisplay('none');
                } else {
                    $(this).addClass('__toggled');
                    $(this).text('Cancel');
                    setFilterDisplay('flex');
                }
            })
        })
    });
});

$(function () {
    const userContentIframes = $('.usercontent iframe');

    userContentIframes.each(function() {
        const thisIframe = $(this);
        thisIframe.wrap('<div class="iframe-wrap"></div>');
    })
})
